import {useEffect, useState} from 'react';

export type StorageBannerTest = 'over' | 'critical' | 'warning' | null;

let current: StorageBannerTest = null;
const listeners = new Set<(value: StorageBannerTest) => void>();

function set(value: StorageBannerTest) {
  current = value;
  listeners.forEach(fn => fn(value));
}

export function toggleStorageBannerTest(value: 'over' | 'critical' | 'warning') {
  set(current === value ? null : value);
}

export function useStorageBannerTest(): StorageBannerTest {
  const [value, setValue] = useState<StorageBannerTest>(current);
  useEffect(() => {
    listeners.add(setValue);
    return () => { listeners.delete(setValue); };
  }, []);
  return value;
}
